import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

// Enregistre une consultation (POST idempotent par (user, resource)).
// Un échec ne doit pas casser l'ouverture du PDF : le container gère le rejet silencieusement.
export const documentaryResourceConsultationLog = createAsyncThunk<void, string, { extra: Partial<Dependencies> }>(
  "documentaryResourceConsultation/log",
  async (resourceId: string, { extra: { sharedRepository } }) => {
    return sharedRepository!.documentaryResourceConsultationLog(resourceId);
  },
);
